export default __webpack_public_path__ + "static/cta-5311a6eed6a2dc17415aa64bce1cc187.svg";